import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import ReportHandler from "../../../report";
import EssenceFiles from "../../Essence/EssenceFiles";
import Blocker from "../../Misc/Blocker";
import ReportForm from "./ReportForm";
export default class ReportRecentItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      report: {},
      html: "",
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.recentItemId !== this.props.recentItemId) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let report = {};
    let html = "";
    if (this.props.recentItemId) {
      report = await this.context.api.q("/report/ready/get", {
        id: this.props.recentItemId,
      });
      if (report) {
        let reportHandler = new ReportHandler();
        reportHandler.result = {};
        await reportHandler.extract(report.id);
        let reportResult = reportHandler.result;
        html = reportResult.html;
      }
    }

    this.setState({ pending: false, report, html });
  };

  render() {
    const { pending, report, html } = this.state;
    return (
      <>
        <Blocker hAuto spinnerFixed on={pending}>
          {this.props.recentItemId && (
            <>
              {report.id && (
                <>
                  <EssenceFiles
                    listOnly
                    essence="report"
                    id={report.id}
                    key={report.id}
                  />
                </>
              )}
              {html && (
                <>
                  <hr />
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: html || "",
                    }}
                  ></div>
                </>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
